import { Pipe, PipeTransform } from '@angular/core';

import { capitalize } from 'lodash-es';

@Pipe({
  name: 'enumValue',
})
export class EnumValue implements PipeTransform {
  transform(value: string): string {
    return value.split('_').map(capitalize).join(' ');
  }
}
